import loadServiceGeo from './loadServiceGeo';
import GeoModel from './geoModel';

export default async function geoManager() {
  const dataGeo = await loadServiceGeo();
  const geoModel = new GeoModel(dataGeo);
  return geoModel;
}
